
import { defineComponent, ref, PropType } from 'vue'
import {
  getUTCDate, getDeliveryDaysOnWeek, getHolidayDays
} from '@/utils/deliveryDate'

import { mapState } from 'vuex'
/**
 * use this to get documentation of vue-datepicker
 * https://vue3datepicker.com/props/calendar-configuration/
 */
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
// import AsahiTypography from '@/components/library/Typography.vue'
import { isEqual, getDay, format } from 'date-fns'
import ChevronLeftIcon from '@/assets/icons/library/chevron-left.svg'
import { IHolidaysConfig } from '@/store/modules/main/intefaces/IConfig'
import ChevronRightIcon from '@/assets/icons/library/chevron-right.svg'
import CalendarIcon from '@/assets/icons/calendar-white.svg'
import CalendarDark from '@/assets/icons/calendar-dark.svg'
import { CommonMutationType } from '@/store/modules/common/mutation-type'

export default defineComponent({
  name: 'DeliveryDatePicker',
  components: {
    // AsahiTypography,
    VueDatePicker
  },
  props: {
    modelValue: {
      type: String,
      required: true
    },
    shipmentId: {
      type: String,
      required: true
    },
    holidayDays: {
      type: Object as PropType<Array<IHolidaysConfig>>,
      default: null
    },
    shipToId: {
      type: String,
      required: true
    },
    changeCalenderBgColor: {
      type: Boolean,
      default: false
    },
    hideIcon: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:modelValue', 'datePickerOpen'],

  data: () => ({
    deliveryDate: '' as string,
    changedShipmentId: false,
    changedShipToId: false,
    ChevronLeftIcon,
    ChevronRightIcon,
    CalendarIcon,
    CalendarDark,
    markers: ref([
      {
        date: new Date(),
        type: 'dot',
        color: '#1A3E13'
      }
    ]),
    inputClassName: 'input-delivery-date',
    darkInputClassName: 'input-delivery-date dark',
    bufferedShipToId: ''
  }),

  computed: {
    ...mapState('basket', [
      'availableDays',
      'availableDate'
    ]),
    ...mapState('main', ['holidaysConfig']),
    ...mapState('catalog', ['shipTos']),

    calenderClass () {
      return this.changeCalenderBgColor ? this.darkInputClassName : this.inputClassName
    },
    availableDates (): string[] {
      return this.$store.state.basket.availableDays
    },

    localeValue () {
      return this.$i18n.locale as string
    },
    holidays () {
      return getHolidayDays(this.holidaysConfig)
    },
    dayOfWeek () {
      return [this.$t('MON'), this.$t('TUE'), this.$t('WED'), this.$t('THU'), this.$t('FRI'), this.$t('SAT'), this.$t('SUN')]
    },
    shipTo () {
      return localStorage.getItem('shipToId')
    },
    defaultShipTo () {
      return localStorage.getItem('defaultShipTo')
    }
  },

  watch: {
    modelValue: {
      handler (value) {
        if (value != null && value !== '') {
          this.deliveryDate = value
        }
      },
      immediate: true
    },
    shipTo: {
      async handler (value, oldValue) {
        this.changedShipToId = oldValue ? value !== oldValue : false
        const shipToId = localStorage.getItem('shipToId')

        if (this.changedShipToId && shipToId) {
          this.availableDays = []
          this.getDaysDetails()
        }
      },
      immediate: true
    },

    shipmentId: {
      handler (value, oldValue) {
        this.changedShipmentId = (oldValue || oldValue === '') ? value !== oldValue : false
        if (this.changedShipmentId && this.shipTo) {
          this.getDaysDetails()
        }
      }
    }
  },

  async mounted () {
    if ((this.availableDays == null || this.availableDays?.length === 0) && this.shipToId) {
      await this.getDaysDetails()
    }
  },
  methods: {
    async getDaysDetails () {
      const shipToIdStore = localStorage.getItem('shipToId')
      if (shipToIdStore) {
        this.$store.commit(CommonMutationType.INCREMENT_LOADING)
        await this.$store.dispatch('basket/GET_AVAILABLE_DAYS', { ShipToId: (this.shipToId || shipToIdStore) })
        this.$store.commit(CommonMutationType.DECREMENT_LOADING)
      }
    },
    getAvailableDates () {
      if (this.availableDates) {
        const availableDates = Array.from(this.availableDates, (availableDate:string) => {
          return getUTCDate(new Date(availableDate))
        })

        return availableDates
      }
      return []
    },

    onDateSelection (value: string) {
      const deliveryDate = new Date(value)
      this.$emit('update:modelValue', getUTCDate(deliveryDate))
    },
    getDayClass (date: Date, _internalDate: Date | Date[] | null) {
      const weekDay = getDay(date)
      const isWeekend = (weekDay % 6) === 0
      const dateStr = format(date, 'yyyy-MM-dd')
      const deliveryDateFormatted = format(new Date(this.deliveryDate), 'yyyy-MM-dd')
      const deliveryDaysOnWeek = getDeliveryDaysOnWeek(this.shipmentId, this.shipTos)
      if (deliveryDateFormatted === dateStr) {
        return 'active-cell'
      }
      if (this.availableDates.includes(dateStr) && deliveryDaysOnWeek.includes(weekDay)) {
        return 'delivery-cell'
      }
      if (dateStr >= deliveryDateFormatted && !isWeekend) {
        return 'working-cell'
      }
      return ''
    },
    onCalendarOpen () {
      if (this.changeCalenderBgColor) {
        this.darkInputClassName = ['input-delivery-date dark', 'open'].join(' ')
      } else {
        this.inputClassName = ['input-delivery-date', 'open'].join(' ')
      }
      this.$emit('datePickerOpen', true)
    },
    onCalendarClose () {
      if (this.changeCalenderBgColor) {
        this.darkInputClassName = ['input-delivery-date dark'].join(' ')
      } else {
        this.inputClassName = ['input-delivery-date'].join(' ')
      }
      this.$emit('datePickerOpen', false)
    },
    openDatePicker () {
      (this.$refs.datePicker as any)?.openMenu()
    }
  }
})
